module.exports = "App.Collections.ContactAddresses = Backbone.Collection.extend({\n\n  model: App.Models.ContactAddress\n  \n});\n"